var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBg1 = function SvgBg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 372,
    viewBox: "0 0 1440 372",
    fill: "none",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 248L34.8 241.111C68.4 234.222 136.8 220.444 205.2 227.333C274.8 234.222 343.2 261.778 411.6 227.333C480 192.889 548.4 96.4445 616.8 68.8889C685.2 41.3333 754.8 82.6667 823.2 110.222C891.6 137.778 960 151.556 1028.4 165.333C1096.8 179.111 1165.2 192.889 1234.8 165.333C1303.2 137.778 1371.6 68.8889 1405.2 34.4444L1440 0V372H1405.2C1371.6 372 1303.2 372 1234.8 372C1165.2 372 1096.8 372 1028.4 372C960 372 891.6 372 823.2 372C754.8 372 685.2 372 616.8 372C548.4 372 480 372 411.6 372C343.2 372 274.8 372 205.2 372C136.8 372 68.4 372 34.8 372H0V248Z",
    fill: "#EBF3FA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg-1.b7d281aa.svg";
export { ForwardRef as ReactComponent };